<template>
    <div class="history-page">
      <div class="history-page__head">
        <div class="wrap-tabs">
          <tabs
              :tabs="side_tabs"
              :currentTab="currentTab"
              :wrapper-class="'default-tabs'"
              :tab-class="'default-tabs__item'"
              :tab-active-class="'default-tabs__item_active'"
              :line-class="'default-tabs__active-line'"
              @onClick="sideChange"
          />
        </div>
<!--        <p>{{__('web_history_Transactions history')}}</p>-->
<!--        <p>{{__('web_history_Market')}}</p>-->
      </div>

      <div v-if="history && !isLoading && currentTab=='history'" :class="(wallets_list.length && wallets_list.length > 1) ? 'history-page__body': 'history-page__body-small'">
        <ScrollPagination
            v-bind:items.sync="history"
            type="post"
            @scrollPagination="scrollPagination"
            :params="params"
        >
          <div v-if="history.data.length" class="history-list" ref="history_list">
            <HistoryItem v-for="(item, key) in history.data" :key="key" v-bind:wallet="$payment(item.wallet_id)" v-bind:history="history.data" v-bind:index="key" v-bind:item="item" :modal_info.sync="modal_info"></HistoryItem>

            <ModalInfoTransaction v-if="modal_info" v-bind:wallet="$payment(modal_info.wallet_id)" v-bind:history="history.data" v-bind:modal_info.sync="modal_info"/>
          </div>

          <div class="block-no-result" v-else>
            <svg width="80" height="80" viewBox="0 0 160 160" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M80 146.667H113.333C133.333 146.667 146.667 133.333 146.667 113.333V79.9998C146.667 61.9998 135.333 48.6665 118.667 46.6665C117.333 46.6665 115.333 46.6665 113.333 46.6665H46.6667C44.6667 46.6665 43.3334 46.6663 41.3334 47.333C24 49.333 13.3334 61.9998 13.3334 79.9998C13.3334 81.9998 13.3334 84.6665 13.3334 86.6665" stroke="#DADADA" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
              <path opacity="0.4" d="M113.328 46.6681H46.6615C44.6615 46.6681 43.3281 46.668 41.3281 47.3346C41.9948 45.3346 43.3282 44.0014 45.3282 42.0014L66.6615 20.0015C75.9948 10.6681 90.6615 10.6681 99.9948 20.0015L111.995 32.0014C115.995 36.0014 117.995 41.3348 118.661 46.6681C117.328 46.6681 115.328 46.6681 113.328 46.6681Z" stroke="#DADADA" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
              <path opacity="0.4" d="M146.667 83.3335H126.667C119.333 83.3335 113.333 89.3335 113.333 96.6668C113.333 104 119.333 110 126.667 110H146.667" stroke="#DADADA" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M59.9974 121.333C59.9974 109.533 50.4641 100 38.6641 100C26.8641 100 17.3307 109.533 17.3307 121.333C17.3307 133.133 26.8641 142.667 38.6641 142.667C50.4641 142.667 59.9974 133.133 59.9974 121.333Z" stroke="#DADADA" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M13.3334 146.667L20 140" stroke="#DADADA" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>

            <p class="block-no-result__text">{{__('web_wallets_No result')}}</p>
          </div>
        </ScrollPagination>
      </div>

      <div v-else-if="market && !isLoadingMarket && currentTab=='market'" :class="(wallets_list.length && wallets_list.length > 1) ? 'page-market': 'page-market page-market--small'">
<!--          <div class="block-price">-->
<!--              <p class="block-price__title">{{__('web_page_market_block_price_title')}}</p>-->
<!--              <p class="block-price__usd">$ {{$primNum(courses[wallets_list[0].symbol])}}</p>-->

<!--              <p class="block-price__percent" :class="(percentProfit(wallets_list[0].symbol) >= 0) ? 'pos' : 'neg'" :style="{color: (percentProfit(wallets_list[0].symbol) >= 0) ? '#01AA4F' : '#F51E38'}">-->

<!--                <svg v-if="percentProfit(wallets_list[0].symbol) >= 0" width="16" height="16" viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg">-->
<!--                  <path d="M5.0496 3.85769C4.94405 3.96323 4.8794 4.1099 4.87961 4.27097L4.87961 4.34187C4.87961 4.66443 5.14074 4.92555 5.46288 4.92514L8.64993 4.92514L3.2587 10.3164C3.03101 10.5441 3.03101 10.9136 3.2587 11.1413C3.48639 11.369 3.85597 11.369 4.08366 11.1413L9.47488 5.7501L9.47488 8.93714C9.47488 9.2597 9.73601 9.52083 10.0582 9.52041L10.129 9.52041C10.4516 9.52041 10.7127 9.25929 10.7123 8.93714L10.7123 4.27097C10.7123 3.94842 10.4512 3.68729 10.129 3.6877L5.46288 3.6877C5.3016 3.6877 5.15514 3.75215 5.0496 3.85769Z" fill="#01AA4F"/>-->
<!--                </svg>-->

<!--                <svg v-else width="16" height="16" viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg">-->
<!--                  <path d="M8.9504 11.1423C9.05595 11.0368 9.12059 10.8901 9.12039 10.729L9.12039 10.6581C9.12039 10.3356 8.85926 10.0744 8.53712 10.0749L5.35007 10.0749L10.7413 4.68363C10.969 4.45594 10.969 4.08636 10.7413 3.85867C10.5136 3.63098 10.144 3.63098 9.91634 3.85867L4.52512 9.2499L4.52512 6.06286C4.52512 5.7403 4.26399 5.47917 3.94185 5.47959L3.87095 5.47959C3.54839 5.47959 3.28727 5.74071 3.28768 6.06286L3.28768 10.729C3.28768 11.0516 3.5488 11.3127 3.87095 11.3123L8.53712 11.3123C8.6984 11.3123 8.84486 11.2479 8.9504 11.1423Z" fill="#F51E38"/>-->
<!--                </svg>-->

<!--                {{percentProfit(wallets_list[0].symbol)}}%-->
<!--              </p>-->
<!--          </div>-->

          <div class="block-chart">
            <VueTradingView :options="{
              symbol: `${wallets_list[0].symbol}USD`,
              interval: 'D',
              theme: 'light',
              width: '100%',
              height: '400',
              chartOnly: true,
              locale: `${languages}`,
              // autosize: true,
              showVolume: false,
              hideDateRanges: false,
              scaleMode: 'Normal',
              noTimeScale: false,
              valuesTracking: '1',
              style: '1',
              // hide_top_toolbar: true,
              // withdateranges: true,
              // hide_legend: true,
              // chartType: 'line',
              // container_id: 'tradingview_86ee0',

            }" />
          </div>

        <div class="block-info-market">
            <div class="block-info-market__item">
              <span>{{__('web_page_market_block_info_market_cap')}}</span>
              <p>{{Intl.NumberFormat('uk',{notation: 'compact'}).format(market.market_cap)}}</p>
            </div>

            <div class="block-info-market__item">
              <span>{{__('web_page_market_block_info_volume')}}</span>
              <p>{{Intl.NumberFormat('uk',{notation: 'compact'}).format(market.volume_24h)}}</p>
            </div>

            <div class="block-info-market__item">
              <span>{{__('web_page_market_block_info_trend')}}</span>
              <p :style="{color: (market.percent_change_24h >= 0) ? '#01AA4F' : '#F51E38'}">{{market.percent_change_24h >= 0 ? '+' : ''}}{{$primNum(market.percent_change_24h)}}%</p>
            </div>

            <div class="block-info-market__item">
              <span>{{__('web_page_market_block_info_supply')}}</span>
              <p>{{Intl.NumberFormat('uk',{notation: 'compact'}).format(market.supply)}}</p>
            </div>

            <div class="block-info-market__item">
              <span>{{__('web_page_market_block_info_fully_diluted_market_cap')}}</span>
              <p>{{Intl.NumberFormat('uk',{notation: 'compact'}).format(market.fully_diluted_market_cap)}}</p>
            </div>

          </div>
      </div>

      <div v-else class="block-loading">
<!--        <DotLoader></DotLoader>-->
        <p class="block-loading__text">{{__('Loading')}}</p>
      </div>
    </div>
</template>

<script>


import HistoryItem from './HistoryItem';
import ScrollPagination from '../../modules/ScrollPagination';
// import DotLoader from 'vue-spinner/src/DotLoader.vue';
import _ from 'lodash';
import ModalInfoTransaction from "../TransactionHistory/ModalInfoTransaction";
import VueTradingView from 'vue-trading-view';

export default {
  name: 'WalletsHistory',
    data: function() {
      return {
          history: null,
          modal_info: null,
          isLoading: false,

          side_tabs: [
            {
              'title': 'Transactions history',
              'value': 'history'
            },
            {
              'title': 'Market',
              'value': 'market'
            }
          ],
          currentTab: 'history',
          isLoadingMarket: false,

          market: null,
          params: {wallet_id: _.map(this.wallets_list, 'id')},

      }
  },
  computed: {
      transaction() {
          return this.$store.getters.transaction
      },
      courses() {
        return this.$store.getters.courses
      },
      charts() {
        return this.$store.getters.charts
      },
      languages() {
        return this.$store.state.language.lang;
      },
  },
  watch:{
      transaction() {
          this.updateHistory();
      },
      wallets_list() {
          this.updateHistory();
          this.fetchMarketInfo();
          this.modal_info = null;
      },

  },
  props: {
      wallets_list: {
          type: Array
      }
  },
  created() {
      this.updateHistory();
      this.fetchMarketInfo();
  },
  methods: {
      updateHistory() {
          this.isLoading = true;
          let request = {
              wallet_id: _.map(this.wallets_list, 'id'),
          };
          this.$http[(process.env.NODE_ENV === 'production') ? 'post' : 'get']('ajax/history', request)

          .then(response=> {
              return response.json()
          })
          .then((response)=> {
              this.history= response.data.history;
              this.isLoading = false;
          })
          .catch((err) => {
              this.httpHandler(err);
              this.isLoading = false;
          });
      },

      scrollPagination(response) {
          let history = this.$cleanObject(this.history);
          history.data = history.data.concat(response.history.data);
          history.next_page_url = response.history.next_page_url;
          this.history = history;
      },

      fetchMarketInfo() {
        this.isLoadingMarket = true;

        this.$http.get('ajax/wallets/market/' + this.wallets_list[0].symbol)

        .then(response => {
          return response.json()
        })
        .then(response => {
          if(response) {
            this.market = response.data;
            this.isLoadingMarket = false;
          }
        }).catch(err => {
          this.httpHandler(err);
          this.isLoadingMarket = false;
        });
      },

      sideChange(newTab) {
        if (newTab != this.currentTab) {
          this.currentTab = newTab;

          if (newTab == 'history') {
            this.updateHistory();
          } else {
            this.fetchMarketInfo();
          }
        }
      },

      percentProfit(currency) {
        let chart_data = this.charts;
        return ((chart_data.day.first[currency] - chart_data.day.last[currency])/(chart_data.day.first[currency] / 100)).toFixed(2);
      },
  },
  components: {
      HistoryItem,
      ScrollPagination,
      // DotLoader,
      ModalInfoTransaction,
      VueTradingView
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
